import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AppHeader from "@/components/header/AppHeader";
import AppQuickMenu from "@/components/quick-menu/AppQuickMenu";
import { useBootstrapAuthQuery } from "@/hooks/useAuth";

export default function Layout() {
  const location = useLocation();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // 저장된 토큰의 유효성 확인 및 사용자 정보 동기화
  useBootstrapAuthQuery();

  useEffect(() => {
    // 라우트 변경 시 스크롤을 최상단으로
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  return (
    <>
      <AppHeader />
      <AppQuickMenu />
      <main className="flex flex-1 flex-col overflow-hidden">
        <div className="flex min-h-0 flex-1 flex-col" ref={scrollContainerRef}>
          <Outlet />
        </div>
      </main>
    </>
  );
}
